import { NextSeo } from "next-seo";
import { FC } from "react";
import { clipText } from "@/lib/text";

interface Props {
  title: string;
  description: string;
  image?: string;
  imageAlt?: string;
  ogType?: string;
}

export const KDevHead: FC<Props> = ({ title, description, image, imageAlt, ogType = "article" }) => {
  return (
    <NextSeo
      title={title}
      description={clipText(description, 120)}
      themeColor="#ffffff"
      openGraph={{
        type: ogType,
        title: title,
        description: clipText(description, 120),
        images: image
          ? [
              {
                url: image,
                alt: imageAlt,
              },
            ]
          : undefined,
      }}
      additionalMetaTags={[{ property: "msapplication-TileColor", content: "#da532c" }]}
      additionalLinkTags={[
        {
          rel: "apple-touch-icon",
          sizes: "180x180",
          href: "/favicon/kdev/kdotdev-favicon.png",
        },
        {
          rel: "icon",
          type: "image/png",
          sizes: "32x32",
          href: "/favicon/kdev/favicon-32x32.png",
        },
        {
          rel: "icon",
          type: "image/png",
          sizes: "16x16",
          href: "/favicon/kdev/favicon-16x16.png",
        },
        {
          rel: "manifest",
          href: "/favicon/kdev/site.webmanifest",
        },
        {
          rel: "mask-icon",
          href: "/favicon/kdev/safari-pinned-tab.svg",
          color: "#a10000",
        },
        {
          rel: "alternate",
          type: "application/rss+xml",
          href: `${process.env.NEXT_PUBLIC_VERCEL_ENV === "production" ? "https://kdotdev.com" : `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`}/kdotdev/rss`,
        },
        {
          rel: "alternate",
          type: "application/atom+xml",
          href: `${process.env.NEXT_PUBLIC_VERCEL_ENV === "production" ? "https://kdotdev.com" : `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`}/kdotdev/feed`,
        },
      ]}
    />
  );
};
